import Collapse from 'bootstrap/js/dist/collapse';
import Modal from 'bootstrap/js/dist/modal';

window.bootstrap = window.bootstrap || {};
window.bootstrap.Collapse = Collapse;
window.bootstrap.Modal = Modal;
